/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events'
],
function(
    $,
    pip,
    pipEvents
){
  var formatTwoDigitNumber = function formatTwoDigitNumber(val){
    return ("0" + Number(val)).slice(-2);
  };
  var media;
  var mediaGenerated;
  var hasThreesixties;
  var mediaManager = {};

  mediaManager.update = function update(){
    if (!pip.products.primary.data.media.mediaList) {
        return;
    }

    mediaGenerated = false;
    hasThreesixties = false;
    processMedia();
    if(hasThreesixties) {
      validate360s();
    } else {
        generateMediaList();
    }
  };

  var processMedia = function processMedia(){
    media = {
      image:{
        order: []
      },
      video:{
        order: []
      },
      threesixty:{
        order: []
      },
      thumbnails: [],
      thumbnails_300: [],
    };
    media.largeImageList = [];
    var mediaList = pip.products.primary.data.media.mediaList;
    var attributeGroups = pip.products.primary.data.attributeGroups; //used to store 360 data
    var file;
    var i;
    var key;
    var len;

    for(i = 0, len = mediaList.length; i < len; i++){

      //IMAGES
      if(mediaList[i].mediaType && mediaList[i].mediaType.indexOf('IMAGE') === 0){
        file = mediaList[i].location.split('/').pop();
        key = file.split('_')[0];

        if(!media.image[key]){
          media.image[key] = {
            type: 'IMAGE',
            id: key
          };
          media.image.order.push(key);
        }

        media.image[key]['url_' + mediaList[i].height] =  mediaList[i].location;

      }

      //VIDEOS
      if(mediaList[i].mediaType && mediaList[i].mediaType.indexOf('VIDEO') !== -1){
        key = mediaList[i].videoId;
        media.video[key] = {
          shortDescription : mediaList[i].shortDescription,
          thumbnail : mediaList[i].thumbnail,
          title : mediaList[i].title,
          video: mediaList[i].video,
          type: 'VIDEO',
          id: key,
          account: '66036796001',
          player: 'ccdb913f-470e-46ba-8d5a-f43d3dbaa347',
          videoStill: mediaList[i].videoStill
        };
        media.video.order.push(key);
      }

    }

    for(i = 0, len = attributeGroups.length; i < len; i++){
      //360
      if(attributeGroups[i].groupType && attributeGroups[i].groupType.indexOf('notDisplayed') !== -1){
        for(var j = 0, groupLen = attributeGroups[i].entries.length; j < groupLen; j++){
          if(attributeGroups[i].entries[j].guid.indexOf('80f81b63-4799-47ea-9a8a-73905c9967f6') !== -1){
            var threesixties = [];
            if(attributeGroups[i].entries[j].value.indexOf(',') !== -1){
              threesixties = attributeGroups[i].entries[j].value.split(',');
            } else {
              threesixties.push(attributeGroups[i].entries[j].value);
            }

            $.each(threesixties,function(key, val){
              var skuParts = val.split('_');
              var sku = skuParts[0];
              var lastTwoDigitsOfSku = sku.substr(-2);
              var spinNumber = formatTwoDigitNumber(skuParts[1]);
              var dataURL = '//' + pip.features.threesixty.hostName + '/spin/' + lastTwoDigitsOfSku + '/' + sku + '/' + sku + '_S' + spinNumber + '.spin';

              media.threesixty[val] = {
                  thumbnail: dataURL + '?thumb&profile=400',
                  json: dataURL,
                  type: 'THREESIXTY',
                  id: val,
                  videoStill: dataURL + '?thumb&profile=1000'
              };
              media.threesixty.order.push(val);
            });
            hasThreesixties = true;
          }
        }
      }
    }
  };

  var validate360s = function isValid360(){
    var timeoutThreshold = 5000;

    var fetchMediaTimeout = setTimeout(function(){
      generateMediaList();
    },timeoutThreshold);

    var getUniqueThreesixtyCount = function(){
      var result = [];
      $.each(media.threesixty.order,function(index,val){
        if ($.inArray(val, result) == -1) result.push(val);
      });
      return result.length;
    };
    var threesixtyCount = getUniqueThreesixtyCount();

      var checkedThreesixtyCount = 0;
      $.each(media.threesixty, function(index, val){
        if (!(val instanceof Array)) {
          var image = new Image();
          image.src = val.thumbnail;
          image.id = val.id;

          image.onload = function() {
            media.threesixty[image.id].isValid = true;
            checkedThreesixtyCount++;
            if(checkedThreesixtyCount === threesixtyCount) {
              clearTimeout(fetchMediaTimeout);
              generateMediaList();
            }
          };

          image.onerror = function() {
            media.threesixty[image.id].isValid = false;
            checkedThreesixtyCount++;
            if (checkedThreesixtyCount === threesixtyCount) {
              generateMediaList();
            }
            pipEvents.threeSixty.threeSixtyThumbnailFailedToLoad.trigger();
          };
        }
      });

  };

  var generateMediaList = function generateMediaList() {
    if (!mediaGenerated) {
      var imageOptions;
      $.each(media.image, function(index, val) {
        $.each(val, function(imgSize, source) {
          imageOptions = {type:'IMAGE', id: index, thumb: source};
          if(imgSize === 'url_145'){
            media.thumbnails.push(imageOptions);
          } else if (imgSize === 'url_300') {
            media.thumbnails_300.push(imageOptions)
          } else if (imgSize === 'url_1000') {
            media.largeImageList.push({type: 'IMAGE', id: index, source: source})
          }
        });
      });

      var videoPosition = 2;
      var videoOptions;
      $.each(media.video, function(index, val) {
        if (!(val instanceof Array)) {
          videoOptions = {type:'VIDEO', id: index, thumb: val.thumbnail, hasIcon: true};
          media.thumbnails.splice(videoPosition, 0, videoOptions);
          media.thumbnails_300.splice(videoPosition, 0, videoOptions);
          media.largeImageList.splice(videoPosition, 0, {type:'VIDEO', id: index, source: val.videoStill, hasIcon: true});
          videoPosition++;
        }
      });

      var threesixtyPosition = media.video.order.length > 1 ? videoPosition : 3;
      var threesixtyOptions;
      $.each(media.threesixty, function(index, val) {
        if (!(val instanceof Array) && media.threesixty[index].isValid) {
          threesixtyOptions = {type:'THREESIXTY', id: index, thumb: val.thumbnail, hasIcon: true, threeSixtyIcon: true };
          media.thumbnails.splice(threesixtyPosition, 0, threesixtyOptions);
          media.thumbnails_300.splice(threesixtyPosition, 0, threesixtyOptions);
          media.largeImageList.splice(threesixtyPosition, 0, {type:'THREESIXTY', id: index, source: val.videoStill, hasIcon: true, threeSixtyIcon: true });
          threesixtyPosition++;
        }
      });

      pipEvents.media.mediaLoaded.trigger();
      mediaGenerated = true;
    }
  };

  mediaManager.getMedia = function getMedia(type, id) {
    if (!id) {
      var initialMedia = media.thumbnails[0];
      return media[initialMedia.type.toLowerCase()][initialMedia.id];
    } else {
      return media[type.toLowerCase()][id];
    }
  };

  mediaManager.setMedia = function setMedia(type, id, data){
    $.extend(media[type.toLowerCase()][id], data);
  };

  mediaManager.updateActiveMedia = function(id, type){
        if(mediaManager.active) mediaManager.previous = mediaManager.active;
        mediaManager.active = !id ? mediaManager.getMedia() : mediaManager.getMedia(type, id);
        mediaManager.active.image = mediaManager.active.type === 'IMAGE';
        mediaManager.active.video = mediaManager.active.type === 'VIDEO';
        mediaManager.active.threesixty = mediaManager.active.type === 'THREESIXTY';
  };

  mediaManager.getThumbnails = function getThumbnails(isLarge){
        if(isLarge) {
            return media.thumbnails_300;
        }
    return media.thumbnails;
  };

  mediaManager.get1000Images = function get1000Images() {
    return media.largeImageList;
  }

  return mediaManager;

});

}.call(window));